import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { MERGE_TAG_KEYS } from "../domain/merge-tags";
import { selectEmailSettings } from "../domain/selectors";
import { useEditorStore } from "../domain/store";
import type { TextBlock } from "../domain/types";
import {
  EmailBuilderRichTextEditor,
  emailBuilderRichTextHeadingLevel,
} from "../editing/richText/EmailBuilderRichTextEditor";
import { resolveInlineTextEditorStyle } from "./inlineTextBridge";

type InlineTextEditorProps = {
  block: TextBlock;
};

export function InlineTextEditor({
  block,
}: InlineTextEditorProps) {
  const { t } = useTranslation();
  const textTheme = useEditorStore(selectEmailSettings);
  const isHeading = block.variant !== "normal";

  return (
    <EmailBuilderRichTextEditor
      blockId={block.id}
      kind={isHeading ? "heading" : "paragraph"}
      headingLevel={isHeading ? emailBuilderRichTextHeadingLevel(block.variant) : undefined}
      content={block.html}
      editorClassName={classNames("email-builder-block-text", "email-builder-inline-text")}
      editorStyle={resolveInlineTextEditorStyle(block, textTheme)}
      ariaLabel={t("Text")}
      placeholder={t("Text")}
      mergeTags={MERGE_TAG_KEYS}
      contentAttribute="data-email-builder-inline-text"
    />
  );
}
